import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DataPlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchDataPlans } from "../../../../features/auth/store/dataPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import DataPlans from "./DataPlan";
import { fetchDataCategories } from "../../../../features/auth/store/dataCategorySlice";

const DataPlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedDataPlan, setSelectedDataPlan] = useState<Product | null>(
    null,
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { dataPlans, loading, error } = useSelector(
    (state: RootState) => state.dataPlans,
  );

  const { dataCategories } = useSelector(
    (state: RootState) => state.dataCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (dataCategories.length == 0) {
      dispatch(fetchDataCategories({ perPage: 40 }));
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchDataPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (searchTerm.trim()) filters.search = searchTerm.trim();
      dispatch(fetchDataPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleDataPlanClick = (dataPlan: Product) => {
    setSelectedDataPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedDataPlan(null);
  };

  if (showDetailView && selectedDataPlan) {
    return (
      // <ProductDetailView dataPlan={selectedDataPlan} onBack={handleBackToList} />
      <DataPlanDetailView
        dataPlan={{
          ...selectedDataPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <DataPlans
      dataPlans={dataPlans || []}
      loading={loading}
      error={error}
      seerchTerm={searchTerm}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onDataPlanClick={handleDataPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default DataPlanRouter;
